import React from "react";
import Query from "react-apollo/Query";
import { Mutation } from "react-apollo";
import { GET_USER_OFFERS, DELETE_OFFER } from "../../../queries";
import { marketLang } from "./marketLang";

class OfferHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reload: false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',    
        };
    }

    deleteOfferEvent = (event, deleteOffer) => {
        event.preventDefault();        
        let newReload = this.state.reload; 
        deleteOffer().then(({ data }) => {
            window.open(`${process.env.SITE_ADDRESS}/withdrawal`, '_top');
            //this.setState({reload: !newReload});
            //console.log(this.state.reload);
        })
    }; 

    render() {
        let self = this;
        return (
            <div className="MarketPageWithdrawalMoneyIn MarketPageWithdrawalMoneyIn02">
                <div className="row width98p">
                    <div className="col-md-12">
                        <div className="CertTable mt10px only-white">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{marketLang.amount[this.state.Language]}</th>
                                        <th>$ARTY</th>
                                        <th>{marketLang.amount_coin[this.state.Language]}</th>
                                        <th>{marketLang.package[this.state.Language]}</th>
                                        {/*<th>Cashback</th>*/}
                                        <th>{marketLang.status[this.state.Language]}</th>
                                        <th>{marketLang.time[this.state.Language]}</th>
                                        <th>{marketLang.detailed[this.state.Language]}</th>
                                        <th>{marketLang.actions[this.state.Language]}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                
                                    <Query query = {GET_USER_OFFERS} variables={{ email: this.props.session.email }}>
                                        {({ data, loading, error}) => {
                                            if (loading) return <div>loading</div>;
                                            if (error) {
                                                window.open(`${process.env.SITE_ADDRESS}/noauth/`, '_top'); 
                                                return <div>error</div>;
                                            }

                                            const AllOffers = data.getCurrentUserOffers.map( function(offer, i) {
                                                let status;
                                                if (offer.status == -1) {status = 'Cancelled'};
                                                if (offer.status == 0) {status = 'Pending'};
                                                if (offer.status == 1) {status = 'Success'};
                                                let cashback = 0;
                                                if (offer.ammount < 200) { cashback = offer.arno * 0.01 }
                                                if (offer.ammount >= 200 && offer.arno < 400) { cashback = offer.arno * 0.03 }
                                                if (offer.ammount >= 400) { cashback = offer.arno * 0.05 }
                                                let form_time = offer.payment_time.split("T");
                                                let form_time2 = form_time[1].split(":");
                                                return (
                                                    <>
                                                    { offer.ammount > 0 ? (
                                                        <tr>
                                                            <td>{offer.ammount.toFixed(2)} $</td>
                                                            <td>{offer.arno}</td>
                                                            <td>{offer.coin_ammount} {offer.currency2}</td>
                                                            <td>{offer.item_name}</td>
                                                            {/*<td>{cashback.toFixed(2)}</td>*/}
                                                            <td>{status}</td>
                                                            <td>{form_time[0]} {form_time2[0]}:{form_time2[1]}</td>
                                                            <td><a href={offer.status_url} target="_blank">Proceed to payment</a></td>
                                                            { offer.status == -1 ? (
                                                                <Mutation mutation={DELETE_OFFER} variables={{ _id: offer._id}} >
                                                                    {(deleteOffer, { data, loading, error }) => {
                                                                        return (
                                                                            <>                                    
                                                                                <button style={{cursor: 'pointer'}} onClick={event => self.deleteOfferEvent(event, deleteOffer)}>Delete</button>
                                                                            </>
                                                                        )
                                                                    }}
                                                                </Mutation>
                                                            ) : (
                                                                <td></td>
                                                            )}
                                                        </tr>
                                                    ) : (
                                                        <></>
                                                    )}
                                                    </>                                                    
                                                )
                                                
                                            });

                                            return <>{AllOffers}</>
                                        }
                                        }
                                    </Query>
                                
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default OfferHistory